/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ComparisonsControllerStartMutationResponse, ComparisonsControllerStart400, ComparisonsControllerStart401, ComparisonsControllerStart403 } from "../../models/comparisonsController/ComparisonsControllerStart";

function getComparisonsControllerStartUrl() {
  const res = { method: 'POST', url: `/api/v1/comparisons` as const }  
  return res
}

/**
 * @description Enqueues the compare-files job. Returns jobId
 * @summary Start a file comparison
 * {@link /api/v1/comparisons}
 */
export async function comparisonsControllerStart(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<ComparisonsControllerStartMutationResponse, ResponseErrorConfig<ComparisonsControllerStart400 | ComparisonsControllerStart401 | ComparisonsControllerStart403>, unknown>({ method : "POST", url : getComparisonsControllerStartUrl().url.toString(), ... requestConfig })  
  return res.data
}